export const GLIDE_CONFIG = {
  type: "slider",
  focusAt: 0,
  gap: 35,
  perView: 2,
  rewind: false,
  peek: { before: 425, after: 200 },
  dragThreshold: false,
  breakpoints: {
    1500: {
      perView: 2,
      peek: { before: 300, after: 100 },
    },
    1100: {
      perView: 2,
      peek: { before: 200, after: 100 },
    },
    900: {
      perView: 2,
      peek: { before: 150, after: 75 },
    },
    820: {
      perView: 1,
      peek: { before: 125, after: 250 },
    },
    768: {
      perView: 1,
      peek: { before: 100, after: 250 },
    },
    700: {
      perView: 1,
      peek: { before: 100, after: 200 },
    },
    650: {
      perView: 1,
      peek: { before: 100, after: 150 },
    },
    600: {
      perView: 1,
      peek: { before: 75, after: 100 },
    },
    540: {
      perView: 1,
      gap: 15,
      peek: { before: 50, after: 50 },
    },
  },
};

export const ERROR_GENERIC = "An unexpected error occured. Please try again later.";

export const FULLPAGE_CONFIG = {
  licenseKey: process.env.VUE_APP_FULLPAGE_KEY,
  verticalCentered: false,
  scrollHorizontally: false,
  fitToSectionDelay: 100,
  navigation: true,
  navigationPosition: "left",
};
